module.exports = __webpack_public_path__ + "img/faq21.416ed77b.png";